import { render, staticRenderFns } from "./TareasComponent.vue?vue&type=template&id=e610f2d4&"
import script from "./TareasComponent.vue?vue&type=script&lang=js&"
export * from "./TareasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports